module.exports = __webpack_public_path__ + "static/img/step_02.2957fc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/step_02.jpg
// module id = yqJ/
// module chunks = 59